import(/* webpackMode: "eager" */ "/builds/eva-kita/typo3/next/app/error.tsx")